import {
  AfterViewInit,
  Directive,
  ElementRef,
  EventEmitter,
  Output,
} from '@angular/core';

import { of } from 'rxjs';

@Directive({
  selector: '[appBackgroundLoaded]',
})
export class BackgroundLoadedDirective implements AfterViewInit {
  @Output() imageLoaded: EventEmitter<boolean> = new EventEmitter<boolean>(
    true,
  );

  constructor(private el: ElementRef) {}

  ngAfterViewInit(): void {
    of(
      window.getComputedStyle(this.el.nativeElement).backgroundImage,
    ).subscribe(style => {
      if (style) {
        this.imageLoaded.emit(true);
      }
    });
  }
}
